import React from 'react';
import styled from 'styled-components';
import { Body1, Body5, Container, Page } from '@ui';
import BackArrowButton from '@ui/buttons/BackArrowButton';
import { FlatButton } from '@ui/buttons';
import { useDispatch } from 'react-redux';
import { showErrorBanner } from '@utils/application';
import { registerMemoryKey } from '@services/agentMemory';

const InputField = styled.input`
  width: 100%;
  padding: 16px;
  border: 1px solid ${({ theme }) => theme.themeColors.border};
  border-radius: 4px;
`;

export const RegisterKeyForm = ({ onCancel, onSuccess }) => {
  const dispatch = useDispatch();
  const [keyValue, setKeyValue] = React.useState('');
  const [saving, setSaving] = React.useState(false);

  const VALID_KEY_PATTERN = /^[a-z0-9_-]+$/;

  const handleSubmit = async () => {
    if (keyValue === '') {
      showErrorBanner('Please enter a key.', null, dispatch);
      return;
    }
    if (!VALID_KEY_PATTERN.test(keyValue)) {
      showErrorBanner(
        'Key must be lowercase alphanumeric with no whitespace (underscores and hyphens are allowed)',
        null,
        dispatch
      );
      return;
    }

    setSaving(true);
    const result = await registerMemoryKey(keyValue);
    if (result) {
      onSuccess();
    } else {
      showErrorBanner('Something went wrong, please try again.', null, dispatch);
    }
    setSaving(false);
  };

  const onChangeKeyValue = (e) => {
    const normalizedValue = e.target.value.trim().toLowerCase();
    setKeyValue(normalizedValue);
  };

  return (
    <Page>
      <BackArrowButton onClick={onCancel} />
      <Container top={40}>
        <Body1 bold>Register New Key</Body1>
        <Container top={24}>
          <InputField value={keyValue} onChange={onChangeKeyValue} />
        </Container>
        <Container top={8}>
          <Body5 secondary>
            Key must be lowercase alphanumeric with no whitespace (underscores and hyphens are allowed)
          </Body5>
        </Container>
        <Container top={40} style={{ textAlign: 'center' }}>
          <FlatButton disabled={saving} fullWidth onClick={handleSubmit}>
            {saving ? 'Registering...' : 'Register'}
          </FlatButton>
        </Container>
      </Container>
    </Page>
  );
};
